import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { isValidEmail } from '../../../shared/util';
import InputGroup from '../../../shared/form/input-group';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            email: {
                value: null,
                error: null,
            },
        };
    }

    /* eslint-disable max-len */
    render({ emailError }) {
        return (
            <newsletter-signup>
                <row className='is-justified-center'>
                    <column className='is-11 is-12-mobile'>
                        <form autoComplete='on'>
                            <h4 className='has-text-center'>Get Your Free Daily<br className='is-visible-mobile' /> Horoscopes by Email!</h4>
                            <row className='is-wrap is-justified-center has-margin-5-left-mobile has-margin-5-right-mobile has-margin-5-top'>
                                <column className='is-5-desktop is-6-tablet-landscape is-7-tablet-portrait is-12-mobile'>
                                    <InputGroup
                                        type='text'
                                        name='email'
                                        placeholder='Enter Your Email'
                                        value={this.state.email.value}
                                        error={this.state.email.error || emailError}
                                        onInput={this.setFormValues}
                                        isHeight='63'
                                    />
                                </column>
                                <column className='is-12-mobile has-padding-5 has-text-center-mobile'>
                                    <button
                                        className='button button-pink-alternate'
                                        onClick={this.validate}
                                    >
                                        Sign Me Up!
                                    </button>
                                </column>
                            </row>
                        </form>
                    </column>
                </row>
            </newsletter-signup>
        );
    }
    /* eslint-enable max-len */

    setFormValues = (e) => {
        let state = {};
        if ((e.type == 'keyup' && e.key == 'Enter') || e.type == 'change' || e.type == 'input') {
            state[e.target.name] = {
                value: e.target.value,
                error: null,
            };

            this.setState(state);
        }
    }

    validate = (e) => {
        e.preventDefault();

        const state = {
            email: {
                value: this.state.email.value,
                error: isValidEmail(this.state.email.value) ? null : 'Please enter a valid email',
            },
        };

        this.setState(state);

        if (!state.email.error) {
            this.props.trackPromo(['Newsletter Signup Form', 'LO Click']);
            this.props.trackEvent(['Newsletter Subscribe', 'LO Click', 'Sign Me Up Button']);
            this.props.updateDetails({ email: this.state.email.value });
            this.props.updateMailLists({ type: 'Newsletter' });
            this.props.routeTo('login-signup');
        }
    }
}

const mapStateToProps = (state) => ({
    emailError: state.user && state.user.emailError,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
    updateDetails: (payload) => dispatch({ type: 'user:updateDetails', payload: payload }),
    updateMailLists: (payload) => dispatch({ type: 'mail-lists:update', payload: payload }),
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);